import React, { useMemo, useState } from 'react';
import ContentLoader from 'react-content-loader';
import { LoadingElement } from '../../themes/loading';
import styled from '../../styled';
import Theme from '../../themes';
const getSize = (value, defaultValue = '100%') => {
    switch (typeof value) {
        case 'string':
            return value;
        case 'number':
            return `${value}px`;
        default:
            return defaultValue;
    }
};
const Wrapper = styled.div `
  width: ${props => getSize(props.width, '100%')};
  height: ${props => getSize(props.height, 'auto')};

  > svg {
    display: block;
  }
`;
const shouldWidthEqualsToHeight = (type) => {
    return ['avatarRect', 'avatarCircle'].includes(type);
};
const getContentHeight = (type, width, height) => {
    if (shouldWidthEqualsToHeight(type)) {
        return width;
    }
    if (type === 'imageRect') {
        return height;
    }
    return LoadingElement.types[type].height;
};
const loadingElementGenerator = (type) => ({ width, height }) => {
    const [contentWidth, setContentWidth] = useState(0);
    const initContentWidth = element => {
        if (element) {
            setContentWidth(element.clientWidth);
        }
    };
    const contentRect = useMemo(() => {
        // fallback to customized width when getting contentWidth failed.
        if (contentWidth === 0) {
            return {
                width: getSize(width, '100%'),
                radius: '50%',
                height: getContentHeight(type, width, height),
            };
        }
        return {
            width: contentWidth,
            radius: contentWidth / 2,
            height: getContentHeight(type, contentWidth, height),
        };
    }, [contentWidth, height, width]);
    return (React.createElement(Wrapper, { ref: initContentWidth, width: width, height: LoadingElement.types[type].height },
        React.createElement(ContentLoader, { primaryColor: Theme.colors.INK_400, primaryOpacity: 0.2, secondaryColor: Theme.colors.INK_400, secondaryOpacity: 0.1, speed: 1.5, style: {
                width: '100%',
                height: `${getSize(contentRect.height, 'auto')}`,
            }, width: contentRect.width, height: contentRect.height }, type === 'avatarCircle' ? (React.createElement("circle", { cx: contentRect.radius, cy: contentRect.radius, r: contentRect.radius })) : (React.createElement("rect", { x: "0", y: "0", rx: LoadingElement.types[type].borderRadius, ry: LoadingElement.types[type].borderRadius, width: contentRect.width, height: contentRect.height })))));
};
export const BodyText = loadingElementGenerator('bodyText');
export const DisplayText = loadingElementGenerator('displayText');
export const SparkLine = loadingElementGenerator('sparkLine');
export const AvatarRect = loadingElementGenerator('avatarRect');
export const ImageRect = loadingElementGenerator('imageRect');
export const AvatarCircle = loadingElementGenerator('avatarCircle');
//# sourceMappingURL=Elements.js.map